import { useEffect, useState } from 'react';

import Typography from 'components/Typography';
import { getTimestamp } from 'utils/date';
import { htmlId } from 'utils/html';

import { CHECK_TIMESTAMP_INTERVAL } from './constants';
import { TimestampProps } from './Timestamp.types';
import { StyledIconCheck, StyledTimestampContainer } from './Timestamp.styles';

const Timestamp = ({ date = new Date(), align = 'left' }: TimestampProps) => {
  const messageDate = new Date(date.getTime());
  const [timeStamp, setTimeStamp] = useState(getTimestamp(messageDate));

  // Handles updating the message time receipts as time passes
  useEffect(() => {
    const intervalId = setInterval(
      () => setTimeStamp(getTimestamp(messageDate)),
      CHECK_TIMESTAMP_INTERVAL,
    );

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <StyledTimestampContainer id={htmlId('message-timestamp')} align={align}>
      <Typography as='span' color='weak' variant='body' size='xs'>
        {timeStamp}
      </Typography>
      <StyledIconCheck id='icon-check' />
    </StyledTimestampContainer>
  );
};

export default Timestamp;
